export default __webpack_public_path__ + "static/media/21_FHNet.42b2a9c5.png";